var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "vuesticScrollbar", staticClass: "vuestic-scrollbar" },
    [
      _c("div", { ref: "scrollbarWrapper", staticClass: "scrollbar-wrapper" }, [
        _c(
          "div",
          {
            ref: "scrollbarContent",
            staticClass: "scrollbar-content",
            on: {
              wheel: _vm.scroll,
              touchstart: _vm.startDrag,
              touchmove: _vm.onDrag,
              touchend: _vm.stopDrag,
              transitionend: _vm.onContentResize,
            },
          },
          [_vm._t("default")],
          2
        ),
        _c("div", { ref: "track", staticClass: "track" }, [
          _c("div", { ref: "thumb", staticClass: "thumb" }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }